import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

export default function DateFilter({
  disabled,
  filterValue,
  updateFilters,
  label,
  views = ['year', 'month', 'day'],
  error = false,
  errorMessage = '',
  required = false,
}) {
  return (
    <DatePicker
      value={filterValue ? dayjs(filterValue) : null}
      label={label}
      disabled={disabled}
      openTo="year"
      views={views}
      sx={{
        '& .MuiInputBase-root': {
          height: 40, // Adjust the height as needed
        },
        '& .MuiOutlinedInput-input': {
          fontSize: 16, // Adjust the font size as needed
        },
        width: '100%', // Ensure the input takes full width
      }}
      onChange={(newValue) => updateFilters(newValue)}
      slotProps={{
        textField: {
          helperText: errorMessage,
          error: !!error,
          fullWidth: true,
          size: 'small',
          required: required,
        },
      }}
    />
  );
}
